import { useState } from "react";
import { Folder, FolderOpen, Home, Pencil, Trash2, GripVertical, Check, X } from "lucide-react";

const Row = ({ active, onClick, children, testId, ...drag }) => (
  <div onClick={onClick} data-testid={testId} {...drag}
    className={`group flex items-center gap-2 rounded-lg px-2.5 py-2 text-sm cursor-pointer transition-colors border ${active ? "bg-amber-500/15 border-amber-500/30 text-slate-50" : "border-transparent text-slate-300 hover:bg-slate-800/60"}`}>
    {children}
  </div>
);

export const SfFolderList = ({ folders, rootCount, current, onSelect, onRename, onDelete, onReorder, canWrite }) => {
  const [dragId, setDragId] = useState(null);
  const [overId, setOverId] = useState(null);
  const [edit, setEdit] = useState(null);

  const drop = (targetId) => {
    if (!dragId || dragId === targetId) return;
    const ids = folders.map((f) => f.id).filter((i) => i !== dragId);
    ids.splice(ids.indexOf(targetId), 0, dragId);
    onReorder(ids);
  };
  const saveEdit = () => { if (edit.name.trim()) onRename(edit.id, edit.name.trim()); setEdit(null); };

  return (
    <div className="space-y-1" data-testid="sf-folder-list">
      <Row active={current === ""} onClick={() => onSelect("")} testId="sf-folder-root">
        <Home className="h-4 w-4 text-amber-500" /><span className="flex-1 font-medium">Radice</span>
        <span className="text-[11px] font-mono text-slate-500">{rootCount}</span>
      </Row>
      {folders.map((f) => (
        <Row key={f.id} active={current === f.id} onClick={() => edit?.id !== f.id && onSelect(f.id)} testId={`sf-folder-${f.id}`}
          draggable={canWrite && edit?.id !== f.id}
          onDragStart={() => setDragId(f.id)} onDragEnd={() => { setDragId(null); setOverId(null); }}
          onDragOver={(e) => { e.preventDefault(); setOverId(f.id); }} onDrop={(e) => { e.preventDefault(); drop(f.id); setOverId(null); }}
          style={overId === f.id && dragId !== f.id ? { boxShadow: "inset 0 2px 0 #f59e0b" } : undefined}>
          {canWrite && <GripVertical className="h-3.5 w-3.5 text-slate-500 cursor-grab shrink-0" />}
          {current === f.id ? <FolderOpen className="h-4 w-4 text-amber-500 shrink-0" /> : <Folder className="h-4 w-4 text-amber-500 shrink-0" />}
          {edit?.id === f.id ? (
            <>
              <input autoFocus value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => { if (e.key === "Enter") saveEdit(); if (e.key === "Escape") setEdit(null); }} data-testid={`sf-folder-rename-input-${f.id}`}
                className="flex-1 min-w-0 h-7 rounded border border-amber-500 bg-transparent px-2 text-sm focus:outline-none" />
              <button type="button" onClick={(e) => { e.stopPropagation(); saveEdit(); }} data-testid={`sf-folder-rename-save-${f.id}`} className="p-1 text-emerald-500"><Check className="h-4 w-4" /></button>
              <button type="button" onClick={(e) => { e.stopPropagation(); setEdit(null); }} className="p-1 text-slate-400"><X className="h-4 w-4" /></button>
            </>
          ) : (
            <>
              <span className="flex-1 truncate" title={f.name}>{f.name}</span>
              <span className="text-[11px] font-mono text-slate-500">{f.count}</span>
              {canWrite && (
                <span className="flex opacity-0 group-hover:opacity-100 transition-opacity">
                  <button type="button" title="Rinomina" onClick={(e) => { e.stopPropagation(); setEdit({ id: f.id, name: f.name }); }} data-testid={`sf-folder-rename-${f.id}`} className="p-1 text-slate-400 hover:text-amber-500"><Pencil className="h-3.5 w-3.5" /></button>
                  <button type="button" title="Elimina" onClick={(e) => { e.stopPropagation(); onDelete(f); }} data-testid={`sf-folder-delete-${f.id}`} className="p-1 text-slate-400 hover:text-red-500"><Trash2 className="h-3.5 w-3.5" /></button>
                </span>
              )}
            </>
          )}
        </Row>
      ))}
    </div>
  );
};
